// extracted by mini-css-extract-plugin
export default {"container":"VideoJsPlayer_container__OibnS"};